import React from 'react';
import { Link } from 'react-router-dom';
import './navbar.css';

const Navbar = () => {

        const handleClick = () => {
          window.scrollTo(0, 0);
        };

    return (
        <div className='navbar'>
            
            <div className='links'>
                <Link to='/' onClick={handleClick} >Rangoli</Link>
                <Link to='/matRangoli' onClick={handleClick}>Mat Rangoli</Link>
                <Link to='/diwali' onClick={handleClick}>Diwali Special</Link>
                <Link to='/chocolates' onClick={handleClick}>Chocolates</Link>
            </div>
            <div className='cart-link'>   
                    <Link to='/cart'>
                        <svg xmlns="http://www.w3.org/2000/svg" color="white" width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="9" cy="21" r="1" />
                            <circle cx="20" cy="21" r="1" />
                            <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h8.72a2 2 0 0 0 2-1.61L23 6H6" />
                        </svg>
                    </Link>
            </div> 
        </div>
    )
}

export default Navbar;
